// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddJournalEntryMutation($input: AddJournalEntryInput!) {
    addJournalEntry(input: $input) {
      journalEntryEdge {
        node {
          id
          entryNumber
          entryDate
          memo
          sourceType
          status
          syncStatus
          postedAt
          totalDebit
          totalCredit
          createdByUser {
            id
            firstName
            lastName
          }
          lines {
            id
            account {
              id
              accountNumber
              name
            }
            debit
            credit
            memo
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'PaginatedJournalEntriesContainer_journalEntries',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'journalEntryEdge',
        },
      ],
    });
  },
};
